
function $parcel$interopDefault(a) {
  return a && a.__esModule ? a.default : a;
}
function $837e4eaebd15e98c$export$2e2bcd8739ae039(routes = [], config = {}) {
    const wrap = (type)=>{
        const orig = history[type];
        return function() {
            const rv = orig.apply(this, arguments);
            window.dispatchEvent(new CustomEvent(type.toLocaleLowerCase(), {
                detail: {}
            }));
            return rv;
        };
    };
    history.pushState = wrap("pushState");
    history.replaceState = wrap("replaceState");
    const handle = async ()=>{
        for (const r of routes){
            const { path: path, handler: handler } = r;
            const found = (location.pathname || "").replace(/\/$/, "").match(path);
            if (found) {
                const detail = {
                    params: found.groups || {},
                    query: location.search.replace(/^\?/, "").split("&").reduce((o, seg)=>{
                        const [key, value] = seg.split("=");
                        return {
                            ...o,
                            [key]: value
                        };
                    }, {}),
                    app: {
                        ...config.app || {},
                        ...r.app || {}
                    },
                    route: r
                };
                window.dispatchEvent(new CustomEvent("router:beforehandler", {
                    detail: detail
                }));
                for (const h of handler)await h(detail);
                window.dispatchEvent(new CustomEvent("router:afterhandler", {
                    detail: detail
                }));
                return;
            }
        }
    };
    handle(); // Run manually for the first tiem.
    [
        "pushstate",
        "replacestate",
        "popstate"
    ].forEach((eventName)=>{
        window.addEventListener(eventName, handle);
    });
}


var $35a52e1c4a364a6d$export$2e2bcd8739ae039 = ({ calendarGetter: calendarGetter, sharableURL: sharableURL, themes: themes, abouts: abouts })=>{
    let customizer = null;
    const init = ({ loc: loc, from: from, to: to, theme: theme })=>{
        customizer = document.createElement("calendar-customizer");
        customizer.innerHTML = `
			${Array.from(abouts).map((about)=>((lang)=>`
			<div slot="about-${lang}" lang="${lang}">${about.innerHTML}</div>
			`)(about.id.replace(/^contents:about:/, ""))).join("")}
			<div slot="themes">${Array.from(themes).map((theme)=>theme.outerHTML).join("")}</div>
		`;
        customizer.setAttribute("sharable", sharableURL);
        document.body.appendChild(customizer);
    };
    const update = ({ loc: loc, from: from, to: to, theme: theme })=>{
        customizer.setAttribute("loc", loc);
        customizer.setAttribute("from", from);
        customizer.setAttribute("to", to);
        customizer.setAttribute("theme", theme);
    };
    window.addEventListener("customizer:action:save", (e)=>{
        const detail = e.detail;
        const { loc: loc, from: from, to: to, theme: theme } = detail;
        const url = [
            [
                "loc",
                loc
            ],
            [
                "from",
                from
            ],
            [
                "to",
                to
            ],
            [
                "theme",
                theme
            ]
        ].reduce((url, [k, v])=>url.replace(`{${k}}`, v), sharableURL);
        history.pushState(detail, "", url);
    });
    window.addEventListener("customizer:action", (e)=>{
        switch(e.detail.name){
            case "print":
                window.print();
                break;
            case "clipboard":
                {
                    const selection = window.getSelection();
                    selection.removeAllRanges();
                    const range = document.createRange();
                    range.selectNode(calendarGetter().shadowRoot.querySelector("table"));
                    selection.addRange(range);
                    document.execCommand("copy");
                    selection.removeAllRanges();
                    break;
                }
            case "link":
                navigator.clipboard.writeText(customizer.sharable);
                break;
        }
    });
    window.addEventListener("router:afterhandler", (e)=>{
        const detail = e.detail;
        if (detail.app.customizer) {
            if (!customizer) init(detail.app);
            update(detail.app);
            customizer.style.display = "block";
        } else if (customizer) customizer.style.display = "none";
    });
};


var $c139ec097e3a9297$exports = {};
$c139ec097e3a9297$exports = "h1{text-align:center;font-size:2.5rem}#locales{text-align:center;font-size:14px;font-weight:600}#locales a{text-decoration:none}.wrapper{width:90%;margin:24px 5% 24px 0;position:relative}.wrapper .calendar-example{transform-origin:top;height:512px;position:relative;overflow:hidden;transform:scale(.8)}.wrapper .calendar-example:before{content:\"\";z-index:1;background:linear-gradient(#fff 0%,#fff0 100%);width:100%;height:40px;display:block;position:absolute;top:-1px;left:0}.wrapper .calendar-example:after{content:\"\";z-index:1;background:linear-gradient(#fff0 0%,#fff 100%);width:100%;height:40px;display:block;position:absolute;bottom:-1px;left:0}.wrapper .calendar-example .calendar{pointer-events:none;animation:15s linear infinite alternate browse-calendar;position:relative;top:0}.wrapper .calendar-description{background:linear-gradient(90deg,#fff0 0%,#fff 30%,#fff 100%);width:35%;height:100%;padding-left:15%;position:absolute;top:0;right:0}.wrapper .calendar-description h2{margin:0 0 14px;font-size:24px}.wrapper .calendar-description .popular-links{margin:0 auto;padding:0;font-size:14px;list-style-position:inside}.wrapper .calendar-description .popular-links li{margin-bottom:6px}.wrapper .calendar-description [role=button]{text-align:center;color:#fff;cursor:pointer;background-color:#000;border:none;border-radius:24px;margin:14px 0 0;padding:12px 14px;font-size:18px;text-decoration:none;display:inline-block}.wrapper .calendar-description [role=button]:hover{background-color:#333}@media (max-width:481px){#page{padding:24px}h1{font-size:1.8rem}.wrapper{width:100%;margin:48px 0 0;display:block}.wrapper .calendar-example{transform-origin:50%;width:100%;height:40vh}.wrapper .calendar-description{text-align:center;width:100%;padding:0;position:relative}.wrapper .calendar-description .popular-links{margin-bottom:12px}}@keyframes browse-calendar{0%{top:0}to{top:-100%}}";


var $385b21b0076268c7$export$2e2bcd8739ae039 = ()=>{
    return ({ params: params, query: query, app: app })=>{
        const { loc: _loc, from: _from, to: _to } = params;
        const { theme: _theme } = query;
        const now = new Date();
        const currentMonth = now.getMonth();
        const currentYear = now.getFullYear();
        const isFirst2MonthsOfYear = currentMonth <= 1; // January or February
        const isLast2MonthsOfYear = currentMonth >= 10; // November or December
        const preferredStartYear = isLast2MonthsOfYear ? currentYear + 1 : currentYear;
        const loc = _loc || "en";
        const from = _from ? parseInt(_from) : preferredStartYear;
        const to = _to ? parseInt(_to) : _from ? from : preferredStartYear + 9;
        const theme = _theme || app.themes && Array.from(app.themes).find((t)=>t.hasAttribute("default")).id.replace(/^theme:/, "");
        return Object.assign(app, {
            loc: loc,
            from: from,
            to: to,
            theme: theme,
            flags: {
                isFirst2MonthsOfYear: isFirst2MonthsOfYear,
                isLast2MonthsOfYear: isLast2MonthsOfYear
            }
        });
    };
};


var $4add3a474377143d$export$2e2bcd8739ae039 = {
    en: {
        landingPageTitle: (d)=>`Multi Year Calendar | 10yearcalendar`,
        landingPageDescription: (d)=>`Visualize your yearly plans with multi-year calendars. Print them and use them, or save them as PDF, Excel, or spreadsheet files.`,
        popularCalendars: (d)=>`Popular Calendars`,
        calendarPageTitle: (d)=>`${d.range} Calendar | ${d.duration} Year Planner`,
        calendarPageDescription: (d)=>`Visualize your ${d.duration}-year plans with the ${d.range} calendar. Print it and use it, or save it as PDF, Excel, or spreadsheet files.`,
        calendarName: (d)=>`${d.range} Calendar (${d.duration}-Year)`,
        makeOwnCalendar: (d)=>`Make Calendar`,
        newYearBanner: (d)=>`\u{1F389} Get a head start on ${d.year} with new calendars!`
    },
    ko: {
        landingPageTitle: (d)=>`Multi Year Calendar | 10yearcalendar`,
        landingPageDescription: (d)=>`\u{C55E}\u{C73C}\u{B85C}\u{C758} \u{C5EC}\u{B7EC}\u{D574}\u{B97C} \u{B2E4}\u{B144} \u{CE98}\u{B9B0}\u{B354}\u{B85C} \u{ACC4}\u{D68D}\u{D558}\u{ACE0} \u{ADF8}\u{B824}\u{BCF4}\u{C138}\u{C694}. \u{D504}\u{B9B0}\u{D2B8}\u{D558}\u{C5EC} \u{C0AC}\u{C6A9}\u{D558}\u{AC70}\u{B098} PDF, \u{C5D1}\u{C140}, \u{C2A4}\u{D504}\u{B808}\u{B4DC}\u{C2DC}\u{D2B8}\u{C5D0}\u{C11C}\u{B3C4} \u{C0AC}\u{C6A9}\u{D574}\u{BCF4}\u{C138}\u{C694}.`,
        popularCalendars: (d)=>`\u{C778}\u{AE30} \u{CE98}\u{B9B0}\u{B354}`,
        calendarPageTitle: (d)=>`${d.range}\u{B144} \u{CE98}\u{B9B0}\u{B354} | ${d.duration}\u{B144} \u{D50C}\u{B798}\u{B108}`,
        calendarPageDescription: (d)=>`${d.duration}\u{B144}\u{C744} \u{ACC4}\u{D68D}\u{D558}\u{ACE0} \u{ADF8}\u{B824}\u{BCFC} \u{C218} \u{C788}\u{B294} ${d.range}\u{B144} \u{CE98}\u{B9B0}\u{B354}. \u{D504}\u{B9B0}\u{D2B8}\u{D558}\u{C5EC} \u{C0AC}\u{C6A9}\u{D558}\u{AC70}\u{B098} PDF, \u{C5D1}\u{C140}, \u{C2A4}\u{D504}\u{B808}\u{B4DC}\u{C2DC}\u{D2B8}\u{C5D0}\u{C11C}\u{B3C4} \u{C0AC}\u{C6A9}\u{D574}\u{BCF4}\u{C138}\u{C694}.`,
        calendarName: (d)=>`${d.range}\u{B144} \u{CE98}\u{B9B0}\u{B354} (${d.duration}\u{B144})`,
        makeOwnCalendar: (d)=>`\u{CE98}\u{B9B0}\u{B354} \u{B9CC}\u{B4E4}\u{AE30}`,
        newYearBanner: (d)=>`\u{1F389} ${d.year}\u{B144} \u{C0C8}\u{D574} \u{ACC4}\u{D68D}\u{C744} \u{C9C0}\u{AE08}\u{BD80}\u{D130} \u{C138}\u{C6CC}\u{BCF4}\u{C138}\u{C694}!`
    },
    ja: {
        landingPageTitle: (d)=>`Multi Year Calendar | 10yearcalendar`,
        landingPageDescription: (d)=>`\u{3053}\u{308C}\u{304B}\u{3089}\u{306E}\u{6570}\u{5E74}\u{9593}\u{3092}\u{591A}\u{5E74}\u{30AB}\u{30EC}\u{30F3}\u{30C0}\u{30FC}\u{3067}\u{8A08}\u{753B}\u{3057}\u{3066}\u{63CF}\u{304D}\u{307E}\u{3057}\u{3087}\u{3046}\u{3002} \u{5370}\u{5237}\u{3057}\u{3066}\u{4F7F}\u{3063}\u{305F}\u{308A}\u{3001}PDF\u{3001}\u{30A8}\u{30AF}\u{30BB}\u{30EB}\u{3001}\u{30B9}\u{30D7}\u{30EC}\u{30C3}\u{30C9}\u{30B7}\u{30FC}\u{30C8}\u{3067}\u{3082}\u{4F7F}\u{3048}\u{307E}\u{3059}\u{3002}`,
        popularCalendars: (d)=>`\u{4EBA}\u{6C17}\u{30AB}\u{30EC}\u{30F3}\u{30C0}\u{30FC}`,
        calendarPageTitle: (d)=>`${d.range}\u{5E74}\u{30AB}\u{30EC}\u{30F3}\u{30C0}\u{30FC} | ${d.duration}\u{5E74}\u{30D7}\u{30E9}\u{30F3}\u{30CA}\u{30FC}`,
        calendarPageDescription: (d)=>`${d.duration}\u{5E74}\u{9593}\u{3092}\u{8A08}\u{753B}\u{3057}\u{3066}\u{63CF}\u{304F}\u{3053}\u{3068}\u{304C}\u{3067}\u{304D}\u{308B}${d.range}\u{5E74}\u{306E}\u{30AB}\u{30EC}\u{30F3}\u{30C0}\u{30FC}\u{3002} \u{5370}\u{5237}\u{3057}\u{3066}\u{4F7F}\u{3063}\u{305F}\u{308A}\u{3001}PDF\u{3001}\u{30A8}\u{30AF}\u{30BB}\u{30EB}\u{3001}\u{30B9}\u{30D7}\u{30EC}\u{30C3}\u{30C9}\u{30B7}\u{30FC}\u{30C8}\u{3067}\u{3082}\u{4F7F}\u{3048}\u{307E}\u{3059}\u{3002}`,
        calendarName: (d)=>`${d.range}\u{5E74}\u{30AB}\u{30EC}\u{30F3}\u{30C0}\u{30FC} (${d.duration}\u{5E74})`,
        makeOwnCalendar: (d)=>`\u{30AB}\u{30EC}\u{30F3}\u{30C0}\u{30FC}\u{4F5C}\u{308A}`,
        newYearBanner: (d)=>`\u{1F389} ${d.year}\u{5E74}\u{306E}\u{8A08}\u{753B}\u{3092}\u{4ECA}\u{3059}\u{3050}\u{7ACB}\u{3066}\u{307E}\u{3057}\u{3087}\u{3046}\u{FF01}`
    }
};


var $c386919c52aaaf0a$export$2e2bcd8739ae039 = ()=>{
    return ({ app: app })=>{
        app.i18n = (0, $4add3a474377143d$export$2e2bcd8739ae039)[app.loc || "en"];
    };
};


const $214639a2ebcd0b35$var$metaDescription = document.querySelector('meta[name="description"]');
const $214639a2ebcd0b35$var$ogTitle = document.querySelector('meta[property="og:title"]');
const $214639a2ebcd0b35$var$ogDescription = document.querySelector('meta[property="og:description"]');
var $214639a2ebcd0b35$export$2e2bcd8739ae039 = ()=>{
    return ({ app: app })=>{
        const { title: title = "", description: description = "" } = app;
        // Update basic SEO stuffs.
        document.title = title;
        $214639a2ebcd0b35$var$metaDescription.setAttribute("content", description);
        // Update OpenGraph stuffs.
        $214639a2ebcd0b35$var$ogTitle.setAttribute("content", title);
        $214639a2ebcd0b35$var$ogDescription.setAttribute("content", description);
        return Object.assign(app, {
            seo: {
                title: title,
                description: description
            }
        });
    };
};


var $24bd19da4fe4924c$export$2e2bcd8739ae039 = (pageName)=>{
    return ({ app: app })=>{
        // app.page.setAttribute('lang', app.loc);
        app.page.setAttribute("data-page-name", pageName);
    };
};


const $e355e7b6d1fff593$export$c3c52e219617878 = [
    (0, $385b21b0076268c7$export$2e2bcd8739ae039)(),
    (0, $c386919c52aaaf0a$export$2e2bcd8739ae039)(),
    ({ app: app })=>{
        const title = app.i18n.landingPageTitle({});
        const description = app.i18n.landingPageDescription({});
        return Object.assign(app, {
            title: title,
            description: description
        });
    },
    (0, $214639a2ebcd0b35$export$2e2bcd8739ae039)(),
    (0, $24bd19da4fe4924c$export$2e2bcd8739ae039)("home"),
    ({ app: app })=>{
        const themeId = (theme)=>theme.id.replace("theme:", "");
        const themeTitle = (theme)=>theme.getAttribute("title");
        const themeDescription = (theme)=>theme.content.querySelector(`meta[name="theme:description"][lang="${app.loc}"]`).getAttribute("content");
        const themeStyle = (theme)=>theme.content.querySelector("style").textContent.replace(/multi-year-calendar/g, `#calendar-${themeId(theme)}`);
        const links = (theme)=>[
                (from)=>({
                        from: from,
                        to: from
                    }),
                (from)=>({
                        from: from,
                        to: from + 2
                    }),
                (from)=>({
                        from: from,
                        to: from + 4
                    }),
                (from)=>({
                        from: from,
                        to: from + 9
                    }),
                (from)=>({
                        from: from,
                        to: from + 14
                    }),
                (from)=>({
                        from: from,
                        to: (parseInt(from / 10) + 1) * 10 - 1
                    })
            ].map((fn)=>{
                const { from: from, to: to } = fn(app.from);
                const range = from === to ? `${from}` : `${from}-${to}`;
                const duration = to - from + 1;
                return {
                    from: from,
                    to: to,
                    range: range,
                    duration: duration,
                    theme: theme
                };
            });
        const showBanner = app.flags.isFirst2MonthsOfYear || app.flags.isLast2MonthsOfYear;
        // Manage banner in body
        let banner = document.querySelector(".banner");
        if (showBanner) {
            if (!banner) {
                banner = document.createElement("aside");
                banner.className = "banner";
                document.body.prepend(banner);
            }
            banner.innerHTML = app.i18n.newYearBanner({
                year: app.from
            });
        } else if (banner) banner.remove();
        app.page.innerHTML = `
			<style>${0, (/*@__PURE__*/$parcel$interopDefault($c139ec097e3a9297$exports))}</style>

			<hgroup>
				<h1>\u{1F4C6} ${app.title}</h1>
			</hgroup>

			<nav id="locales">
				<a href="/" lang="en">[English]</a>
				<a href="/ko" lang="ko">[\u{D55C}\u{AE00}]</a>
				<a href="/ja" lang="ja">[\u{65E5}\u{672C}\u{8A9E}]</a>
			</nav>
			${Array.from(app.themes).map((theme)=>`

			<section class="wrapper">

				<style>${themeStyle(theme)}</style>

				<section class="calendar-example">
					<multi-year-calendar
						id="calendar-${themeId(theme)}"
						class="calendar"
						loc="${app.loc}"
						from="${app.from}"
						to="${app.from + 2}"
						note="${theme.dataset.note || 0}"
					></multi-year-calendar>
				</section>

				<section class="calendar-description">
					<h2>${themeTitle(theme)}</h2>
					<p>${themeDescription(theme)}</p>
					<menu class="popular-links">${links(theme).map((link)=>`<li><a href="/${app.loc}/${link.from}/${link.to}?theme=${themeId(link.theme)}">
							${app.i18n.calendarName({
                    range: link.range,
                    duration: link.duration
                })}
						</a></li>`).join("")}
					</menu>
					<a role="button" href="/${app.loc}/${app.from}/${app.to}?theme=${themeId(theme)}">
						\u{1F4C6} ${app.i18n.makeOwnCalendar()}
					</a>
				</section>

			</section>

			`).join("")}

		`;
    }
];
var $e355e7b6d1fff593$export$2e2bcd8739ae039 = {
    handler: $e355e7b6d1fff593$export$c3c52e219617878
};


var $5e6f7a5d29770194$exports = {};
$5e6f7a5d29770194$exports = "#header{color:#fff;background-color:#000;justify-content:space-between;padding:4px 12px;display:flex;position:-webkit-sticky;position:sticky;top:0}#header h1{margin:0;padding:0;font-size:14px;font-weight:400}#header nav ul{margin:0;padding:0;font-size:14px;list-style:none}#header nav li{margin:0;padding:0;display:inline-block}#header nav a{color:#fff}[slot^=about-] details{margin-bottom:10px}[slot^=about-] details summary{cursor:pointer}[slot^=about-] details p{padding-left:12px}[slot^=about-] details mark[as=button]{background:0 0;font-family:monospace}multi-year-calendar::part(calendar){width:100%;display:block;overflow-x:auto}@media print{#header{display:none}multi-year-calendar::part(calendar){display:table}multi-year-calendar::part(year-calendar){break-inside:avoid}}";






const $3da16461fafe7d7a$export$c3c52e219617878 = [
    (0, $385b21b0076268c7$export$2e2bcd8739ae039)(),
    (0, $c386919c52aaaf0a$export$2e2bcd8739ae039)(),
    ({ app: app })=>{
        const { from: from, to: to } = app;
        const range = from === to ? `${from}` : `${from}-${to}`;
        const duration = to - from + 1;
        const title = app.i18n.calendarPageTitle({
            range: range,
            duration: duration
        });
        const description = app.i18n.calendarPageDescription({
            range: range,
            duration: duration
        });
        return Object.assign(app, {
            title: title,
            description: description
        });
    },
    (0, $214639a2ebcd0b35$export$2e2bcd8739ae039)(),
    (0, $24bd19da4fe4924c$export$2e2bcd8739ae039)("calendar"),
    ({ app: app })=>{
        const theme = Array.from(app.themes).find((t)=>t.id === `theme:${app.theme}`);
        const themeStyle = theme.content.querySelector("style").textContent;
        const options = {
            // Calendar options
            loc: app.loc,
            from: app.from,
            to: app.to,
            // Theme options
            note: theme.dataset.note || 0
        };
        // if (!theme) {
        // 	// TODO: Error handling
        // }
        app.page.innerHTML = `
			<style>${0, (/*@__PURE__*/$parcel$interopDefault($5e6f7a5d29770194$exports))}</style>
			<style>${themeStyle}</style>

			<header id="header">
				<h1 id="title">\u{1F4C6} ${app.seo.title}</h1>
				<nav>
					<ul>
						<li><a href="/">[Home]</a></li>
					</ul>
				</nav>
			</header>

			<multi-year-calendar
				id="calendar"
				loc="${options.loc}"
				from="${options.from}"
				to="${options.to}"
				note="${options.note}"
			></multi-year-calendar>
		`;
    }
];
var $3da16461fafe7d7a$export$2e2bcd8739ae039 = {
    handler: $3da16461fafe7d7a$export$c3c52e219617878
};


{
    const adsense = document.createElement("script");
    adsense.setAttribute("async", "");
    adsense.setAttribute("crossorigin", "anonymous");
    adsense.setAttribute("src", "https://pagead2.googlesyndication.com/pagead/js/adsbygoogle.js?client=ca-pub-5772084038711393");
    const gtm = document.createElement("script");
    gtm.setAttribute("async", "");
    gtm.setAttribute("src", "https://www.googletagmanager.com/gtag/js?id=G-KCFDXXWGKX");
    document.head.appendChild(adsense);
    document.head.appendChild(gtm);
    window.dataLayer = window.dataLayer || [];
    window.gtag = function gtag1() {
        dataLayer.push(arguments);
    };
    gtag("js", new Date());
    gtag("config", "G-KCFDXXWGKX");
    // Track customizer actions (e.g., print, copy, link, ...)
    window.addEventListener("customizer:action", (e)=>{
        gtag("event", e.type.replace(/:/g, "_"), e.detail);
    });
}const $ff8f9da16e98e242$var$page = document.querySelector("#page");
const $ff8f9da16e98e242$var$themes = document.querySelectorAll('template[id^="theme:"]');
$ff8f9da16e98e242$var$page.addEventListener("click", (e)=>{
    const name = e.target.tagName;
    const href = e.target.getAttribute("href");
    if (name !== "A" || !href) return;
    if (!(href === "" || href.startsWith("/"))) return;
    e.preventDefault();
    return window.history.pushState({}, "", href);
});
(0, $35a52e1c4a364a6d$export$2e2bcd8739ae039)({
    calendarGetter: ()=>document.querySelector("#calendar"),
    sharableURL: `${"https://10yearcalendar.app"}/{loc}/{from}/{to}?theme={theme}`,
    themes: $ff8f9da16e98e242$var$themes,
    abouts: document.querySelectorAll('template[id^="contents:about:"]')
});
(0, $837e4eaebd15e98c$export$2e2bcd8739ae039)([
    {
        path: /^\/?$/,
        handler: (0, $e355e7b6d1fff593$export$2e2bcd8739ae039).handler,
        app: {}
    },
    {
        path: /^\/(?<loc>[a-z]{2})$/,
        handler: (0, $e355e7b6d1fff593$export$2e2bcd8739ae039).handler,
        app: {}
    },
    {
        path: /^\/(?<loc>[a-z]{2})\/(?<from>\d{4})$/,
        handler: (0, $3da16461fafe7d7a$export$2e2bcd8739ae039).handler,
        app: {
            customizer: true
        }
    },
    {
        path: /^\/(?<loc>[a-z]{2})\/(?<from>\d{4})\/(?<to>\d{4})$/,
        handler: (0, $3da16461fafe7d7a$export$2e2bcd8739ae039).handler,
        app: {
            customizer: true
        }
    }
], {
    app: {
        page: $ff8f9da16e98e242$var$page,
        themes: $ff8f9da16e98e242$var$themes
    }
});


//# sourceMappingURL=index.7d88d2ca.js.map
